import React from 'react';

import { aiMessages } from '@atlaskit/editor-common/ai-messages';
import type { ExtensionManifest } from '@atlaskit/editor-common/extensions';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';

import { AIPanelRenderer } from '../../ai-panel-renderer/AIPanelRenderer';
import type { AIManifest, AIPanelParameters } from '../../types';

const buildActionItemsPanelManifest = ({
	intl,
	providerFactory,
}: AIManifest): ExtensionManifest<AIPanelParameters> => {
	return {
		title: intl.formatMessage(aiMessages.actionItemsPageTitle),
		type: 'com.atlassian.ai-blocks',
		key: 'ai-action-items-block',
		description: intl.formatMessage(aiMessages.actionItemsPageDescription),
		icons: {
			// Ignored via go/ees005
			// eslint-disable-next-line require-await
			'48': async () => () => (
				<AtlassianIntelligenceIcon label={intl.formatMessage(aiMessages.actionItemsPageTitle)} />
			),
		},
		modules: {
			nodes: {
				aiActionItemsBodiedExtension: {
					type: 'bodiedExtension',
					// Ignored via go/ees005
					// eslint-disable-next-line require-await
					render:
						// oxlint-disable-next-line require-await
						async () =>
							({ node }) => {
								return <AIPanelRenderer node={node} providerFactory={providerFactory} />;
							},
				},
			},
		},
	};
};

export default buildActionItemsPanelManifest;
